module.exports = __webpack_public_path__ + "static/media/industry1.f16ef876.png";